module.exports = __webpack_public_path__ + "img/rf5.a58980a7.png";